export default __webpack_public_path__ + "static/media/cross.553d1d15.svg";